module.exports = {
      id: "expand_more-usage",
      viewBox: "0 0 13 8",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#expand_more",
      toString: function () {
        return this.url;
      }
    }